// limit settings
export default {
  datasets: 500,
  geofences: 500,
  simulations: 500,
  commuteOffers: 500,
  projects: 500
};
